/**
 * An enumeration of all the possible colors of a label box.
 *
 * Per-finding-type colors follow the brand design palette defined in the UI spec.
 */
export enum LabelBoxColors {
  CariesInitial = "#f2f2f2",
  CariesModerate = "#ffb04f",
  CariesAdvanced = "#ff4747",
  Tooth = "#a1a1a1",
  Material = "#73beff",

  BonelossAnchor = "#f2f2f2",
  BonelossInitial = "#f2f2f2",
  BonelossModerate = "#ffb04f",
  BonelossAdvanced = "#ff4747",

  // Per-finding-type brand colors
  Caries = "#C1121F",
  BoneLoss = "#5C677D",
  MaterialBrand = "#6A4C93",
  Fracture = "#F77F00",
  Calculus = "#D4A017",
  Infection = "#FF006E",
  DefectiveRestoration = "#008C8C",
  Plaque = "#7ED957",
  GumRecession = "#FF6F61",
  GumInflammation = "#FF2D55",
  MissingTooth = "#2979FF",
}
